// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2r5Jq","row":"Node_row__1rE10","label":"Node_label__ncyob","footer":"Node_footer__3GKqP"};